import { twClassMerge } from '@healthhub/react-ui';
import { Divider, Typography } from 'antd';
import { useContext } from 'react';

import { HealthHubIcon } from '@shared/assets';
import { sitecoreHomeBaseUrl } from '@shared/configs/configs/config';
import { StylesConfigContext } from '@shared/context/StylesConfigContextWrapper';
import { MESSAGE_ACTIONS_KEYS } from '@shared/utils/bridge';

const { Text } = Typography;

const PageFooter = () => {
  const { styles } = useContext(StylesConfigContext)!;

  return (
    <footer className={twClassMerge('flex justify-between bg-transparent px-4 py-6', styles?.mobileFooter)}>
      <div className="flex items-center">
        <a
          data-navigation={MESSAGE_ACTIONS_KEYS.externalLink}
          href={`${sitecoreHomeBaseUrl()}/privacy-policy`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Privacy Policy
        </a>
        <Divider className="border-black" type="vertical" />
        <a
          data-navigation={MESSAGE_ACTIONS_KEYS.externalLink}
          href={`${sitecoreHomeBaseUrl()}/terms-of-use`}
          rel="noopener noreferrer"
          target="_blank"
        >
          Terms of Use
        </a>
      </div>
      <div className="flex flex-col">
        <Text className="text-[0.5rem] text-[#59595C]">Powered by</Text>
        <a className="h-auto w-28 lg:block" href={sitecoreHomeBaseUrl()}>
          <img alt="HealthHub" className="size-full" src={HealthHubIcon} />
        </a>
      </div>
    </footer>
  );
};

export default PageFooter;
